import React, {
    useEffect,
    useRef,
    useState,
    useCallback,
    useContext
  } from "react";
  import { useParams, useLocation, useNavigate } from "react-router-dom";
  import _axios from "../axios";
  import Cookies from "js-cookie";
  import buildLink from "../urls";
  import { AiOutlineClose } from "react-icons/ai";
  import { FaTrashAlt ,FaFilter} from 'react-icons/fa';
  import PointsLoader from "../components/PointsLoader";
  import SingleProducts from "../components/SingleProduct";
  import { AccountContext } from "../contexts/AccountContext";
  import { CurrencyContext } from "../contexts/CurrencyContext";
  
  export default function Recommended() {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
  
    const [isLargeScreen, setIsLargeScreen] = useState(false);


  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      setIsLargeScreen(width >= 1024);
    };

    window.addEventListener("resize", checkScreenSize);
    checkScreenSize(); 

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  
    const [state] = useContext(AccountContext);
    const dataInformation = useContext(CurrencyContext);
  
    const [filterProduct, setFilterProduct] = useState();
    const [products, setProducts] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [filterOptions, setFilterOptions] = useState([]);
    const [showMobileFilter, setShowMobileFilter] = useState(false);
  
    const partRef = useRef("");
    const nextPageRef = useRef(1);
    const observer = useRef(null);
    const hasPostedAnalytics = useRef(false);
  
    const extractFiltersFromURL = () => {
      const searchParams = new URLSearchParams(location.search);
      const filters = {};
      searchParams.forEach((value, key) => {
        if (key.startsWith("filter_")) {
          filters[key] = value.split(",");
        }
      });
      return filters;
    };
  
    const buildQueryStringFromFilters = (filterObj) => {
      return Object.entries(filterObj)
        .map(([key, values]) => `${key}=${values.join(",")}`)
        .join("&");
    };
  
    const fetchData = useCallback(async () => {
      if (!id || isLoading || !hasMore) return;
  
      setIsLoading(true);
      const queryFilters = extractFiltersFromURL();
      const hasFilter = Object.keys(queryFilters).length > 0;
      const filterQueryString = buildQueryStringFromFilters(queryFilters);
  
      const link =
        buildLink("recommended", undefined, undefined, window.config["site-url"]) +
        `&source_id=1` +
        (partRef.current ? `&part=${partRef.current}` : "") +
        `&recommended_id=${encodeURIComponent(id)}` +
        (hasFilter
          ? "&has_filter=true&admin_quantity=true"
          : `&page=${nextPageRef.current}`) +
        (hasFilter ? `&${filterQueryString}` : "") +
        `&view=${window.innerWidth > 650 ? "web_desktop" : "web_mobile"}`;
  
      try {
        const response = await _axios.get(link);
        const data = response?.data?.data;
        setFilterProduct(data?.filters);
        setFilterOptions(data?.filters?.flatMap(f => f.options?.map(opt => opt.id)) || []);
  
        const newProducts = data?.products || [];

        setFilterData(hasFilter ? newProducts : []);

        if (newProducts.length > 0) {
          setProducts(prev => [...prev, ...newProducts]);
  
          partRef.current = data?.next_part || "";
          nextPageRef.current = data?.next_page || null;
  
          if (!hasPostedAnalytics.current) {
            hasPostedAnalytics.current = true;
  
            const dataSocial = {
              ...data?.social_data,
              fbp: Cookies.get("_fbp"),
              from: "catalog",
              contents: [],
              banner_recommended_id: state.BannerRecommendedGrid2ID,
              fbc: Cookies.get("_fbc"),
              ttp: Cookies.get("_ttp"),
              link: window.location.href,
              view_type: "recommended",
              source_type: "home",
              source_type_id: "",
              view_type_id: id,
              is_admin: !!Cookies.get("ATDetails"),
            };
  
            if (dataInformation?.data?.analytics_url) {
              _axios.post(dataInformation.data.analytics_url, dataSocial);
            }
          }
  
          if (!data?.next_page && !data?.next_part) {
            setHasMore(false);
          }
        } else {
          setHasMore(false);
        }
      } catch (err) {
        setHasMore(false);
      } finally {
        setIsLoading(false);
      }
    }, [id, isLoading, hasMore, location.search]);
  
    useEffect(() => {
      fetchData();
    }, []);
  
    const lastElementRef = useCallback(
      (node) => {
        if (isLoading) return;
        if (observer.current) observer.current.disconnect();
  
        observer.current = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting && hasMore) {
            fetchData();
          }
        });
  
        if (node) observer.current.observe(node);
      },
      [fetchData, isLoading, hasMore]
    );
  
    const parseFilter = async (filter_type, filter_id, isRemoving = false) => {
      setSelectedFilters(prev => {
        const existing = prev[filter_type] || [];
        const updated = isRemoving
          ? existing.filter(fid => fid !== filter_id)
          : [...new Set([...existing, filter_id])];
  
        const newFilters = {
          ...prev,
          [filter_type]: updated,
        };
  
        const filterQuery = buildQueryStringFromFilters(newFilters);
        navigate(`?has_filter=true&${filterQuery}&last=${filter_type.slice(7, 8)}`);
  
        return newFilters;
      });
  
      try {
        const link = `${buildLink("recommended", undefined, undefined, window.config["site-url"])}&source_id=1&recommended_id=${encodeURIComponent(id)}&has_filter=true&admin_quantity=true&last=${filter_type.slice(7, 8)}&${filter_type}=${selectedFilters[filter_type]?.join(",")}&view=${window.innerWidth > 650 ? "web_desktop" : "web_mobile"}`;
        const response = await _axios.get(link);
        const newData = response?.data?.data?.products || [];
        setFilterData(newData);
        return newData;
      } catch (error) {
      }
    };
  
    const checkSingleFilter = (type, name, filter) => {
      const isSelected = filterOptions.includes(filter.id);
  
      if (["Color", "Light color"].includes(name)) {
        return isSelected
          ? "rounded-full border border-dblue"
          : "rounded-full border relative border-dgreyRate cursor-pointer hover:shadow";
      }
  
      if (["Shoes Size", "Size by Age", "jeans Size", "Socks"].includes(name)) {
        return isSelected
          ? "border rounded text-dblue border-dblue"
          : "border rounded relative border-dgreyRate cursor-pointer hover:shadow p-2";
      }
  
      if (type === "filter_options") {
        return (
          <input type="checkbox" className="" defaultChecked={isSelected} />
        );
      }
  
      return <input type="checkbox" className="" />;
    };
  
    const handleClearFilters = () => {
      setSelectedFilters({});
      navigate(window.location.pathname, { replace: true });
     window.location.reload();
    };
  
    const toggleFilters = (e) => {
      const sender = e.target;
      const next = sender.parentNode.nextElementSibling;
      if (next.style.display === "block") {
        next.style.display = "none";
        sender.textContent = "See all";
      } else {
        next.style.display = "block";
        sender.textContent = "See less";
      }
    };
  
    function FilterItem({ type, item, onClick }) {
      const [selected, setSelected] = useState(false);
  
      useEffect(() => {
        const selectedIds = selectedFilters[type] || [];
        setSelected(selectedIds.includes(item.id));
      }, [selectedFilters, type, item]);
  
      const handleFilterClick = () => {
        const newSelected = !selected;
        setSelected(newSelected);
        onClick(type, item.id, !newSelected);
      };
  
      return (
        <div
          className="flex items-center cursor-pointer hover:text-dblue"
          onClick={handleFilterClick}
          id={item.id}
        >
          <input
            type="checkbox"
            checked={selected}
            onChange={() => {}}
            onClick={(e) => e.stopPropagation()}
          />
          <h1 className="mx-2 text-d14 font-light select-none">
            {item.name.replace(/&amp;/g, "&")}
          </h1>
          {item.count && (
            <span className="text-d14 text-right font-light opacity-70">
              ({item.count})
            </span>
          )}
        </div>
      );
    }
  
    return (
      <div className="container">
         {filterProduct && (
            <div className="flex justify-center">
              <button onClick={() => setShowMobileFilter(true)}>
                <span>Filter</span>
                <i className="icon icon-filter ml-1"></i>
              </button>
            </div>
          )}

            {filterData.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 p-2 gap-2 bg-white">
            {filterData.map((item, index) => (
            <div key={index}>
                <SingleProducts item={item} sort_order={index+1} />
            </div>
            ))}
        </div>
        ) : (
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 p-2 gap-2 bg-white">
         
  
          {products.map((item, index) => (
            <div key={index}>
              <SingleProducts item={item} sort_order={index + 1} />
            </div>
          ))}
  
          <div ref={lastElementRef}></div>
        </div>
        )}

        {filterProduct && showMobileFilter && (
 <div className={`bg-white fixed ${isLargeScreen? "w-64  translate-x-[-5px]  " : "w-full" } z-50 top-0 h-screen py-3 pb-12`}>
            <div className="flex justify-between pl-2 pr-7">
            <div className="text-d22 flex w-full">
        <div>Filters</div>
        <button className="text-d18 ml-2"onClick={() => fetchData()}><FaFilter/></button>
        <button className="text-d22 ml-2 text-dbase" onClick={handleClearFilters}><FaTrashAlt/></button>
        </div>

      <div className="text-d25 py-1 ml-2" onClick={() => setShowMobileFilter(false)}>
        <AiOutlineClose />
      </div>
    </div>
    <div className="w-full h-screen pl-2 pr-7 pb-12 overflow-y-auto bg-white">
      {Object.keys(filterProduct).map((key) => (
        <div className="py-2" key={key}>
          {filterProduct[key].items.length > 0 && (
            <div className="text-dcf pr-semibold leading-lfc font-bold capitalize">
              {filterProduct[key].name}
            </div>
          )}
          <div style={{ display: "block" }}>
            {key ? (
              <div>
                {filterProduct[key].items.slice(0, 5).map((filter) => (
                  <div key={Math.random()}>
                    {(filterProduct[key].name === "Light color" ||
                      filterProduct[key].name === "Color") &&
                    filter?.option_id ? (
                      <div
                        className="my-2 flex items-center cursor-pointer hover:text-dblue"
                        key={filter.name}
                        onClick={() => parseFilter(filterProduct[key].id, filter.id)}
                      >
                        <div className="flex w-10/12">
                          <span
                            className={`flex w-7 h-7 ${checkSingleFilter(
                              filterProduct[key]?.id,
                              filterProduct[key].name,
                              filter
                            )}`}
                          >
                            {filter?.image && (
                              <img
                                src={filter.image}
                                style={{ padding: `1px` }}
                                className="w-12/12 rounded-full border border-dgreyRate"
                                alt="Not Found"
                                width="28"
                                height="28"
                              />
                            )}
                          </span>
                          <p className="py-1 mx-2 text-d14 leading-dtight w-8/12 font-light">
                            {filter.name}
                          </p>
                        </div>
                        <span className="flex w-2/12"></span>
                        <span className="text-d14 text-right font-light opacity-70">
                          ({filter.count})
                        </span>
                      </div>
                    ) : (
                      <div>
                        <p
                          className="my-2 flex items-center cursor-pointer hover:text-dblue"
                          key={filter.name}
                          onClick={() => parseFilter(filterProduct[key].id, filter.id)}
                        >
                         <FilterItem
                            type={filterProduct[key].id}
                            item={filter}
                            selectedFilters={selectedFilters}
                            onClick={(type, id, isRemoving) => {
                                parseFilter(type, id, isRemoving);
                            }}
                            />

                        </p>
                      </div>
                    )}
                  </div>
                ))}
                <div>
                  <label
                    className={
                      filterProduct[key].items.length > 5
                        ? `text-dblue text-xs cursor-pointer`
                        : "hidden"
                    }
                    onClick={(e) => toggleFilters(e.target)}
                  >
                    See All
                  </label>
                </div>
                <div style={{ display: "none" }}>
                  {filterProduct[key].items
                    .slice(5, filterProduct[key].items.length)
                    .map((filter) => (
                      <div key={Math.random()}>
                        {(filterProduct[key].name === "Light color" ||
                          filterProduct[key].name === "Color") &&
                        filterProduct[key]?.option_id ? (
                          <div
                            className="my-2 flex items-center cursor-pointer hover:text-dblue"
                            key={filter.name}
                          >
                            <div className="flex w-10/12">
                              <span
                                className={`flex w-7 h-7 ${checkSingleFilter(
                                  filterProduct[key].id,
                                  filterProduct[key].name,
                                  filter
                                )}`}
                              >
                                {filter?.image && (
                                  <img
                                    src={filter.image}
                                    style={{ padding: `1px` }}
                                    className="w-12/12 rounded-full border border-dgreyRate"
                                    alt="Not Found"
                                    width="28"
                                    height="28"
                                    loading="lazy"
                                  />
                                )}
                              </span>
                              <p className="py-2 mx-2 text-d14 leading-dtight w-8/12 font-light">
                                {filter.name}
                              </p>
                            </div>
                            <span className="flex w-1/12"></span>
                            <span className="text-d14 text-right font-light opacity-70">
                              ({filter.count})
                            </span>
                          </div>
                        ) : (
                          <div>
                            <p
                              className="my-2 flex float items-center cursor-pointer hover:text-dblue"
                              key={filter.name}
                            >
                             <FilterItem
                                type={filterProduct[key].id}
                                item={filter}
                                selectedFilters={selectedFilters}
                                onClick={(type, id, isRemoving) => {
                                    parseFilter(type, id, isRemoving);
                                }}
                                />

                            </p>
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      ))}
    </div>
  </div>
)}
  
        {isLoading && <PointsLoader />}
      </div>
    );
  }
  